import styled from "styled-components";

export const Style = styled.div`
  padding: 40px;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);

  .flex-c {
    display: flex;
    flecx-direction: column;
    justify-content: center;
  }

  .header-cont {
    display: flex;
    margin-bottom: 30px;

    .left {
      flex: 1;

      h4 {
        margin-bottom: 0;
        font-weight: 600;
      }
    }

    .right {
      display: flex;
      gap: 8px;

      svg {
        color: #F97066;
        font-size: 14px;
      }

      .ant-btn {
        border-radius: 6px;

        &.del-btn {
          border-color: #F97066;
        }

        &.btn-blue {
          border-color: var(--color-primary-70);
          color: var(--color-primary-70);
        }
      } 
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: var(--size);

    .row-item {
      display: flex;

      .label {
        font-size: 14px;
        font-weight: 500;
      }

      .left {
        flex: 1;

        label {
          font-size: 14px;
          font-weight: 500;
        }
      }

      .right {
        label {
          font-size: 14px;
          font-weight: 600;
          color: #667085;
        }
      }
    }
  }

  .subjects {
    margin-top: 30px;

    .label {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: var(--size);
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .item {
        display: flex;
        gap: var(--size);
        border: 1px solid #EAECF0;
        border-radius: 2px;
        padding: 8px 10px;

        label {
          margin-bottom: 0px;
          font-weight: 500;
          font-size: var(--font-size-lg);
        }
      }
    }
  }
`;
